import React from 'react';
import { Icon } from '@osmosis/tailwind-ui/components/Icon';
import { H2 } from '@osmosis/tailwind-ui/components/Text';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { text2 } from '@osmosis/tailwind-ui/styles/text';
import Image from 'next/image';
import { faFolderOpen } from '@fortawesome/pro-duotone-svg-icons/faFolderOpen';
import { LoggedOutProductLibraryContainsItem } from '../../../types/library';
import { assets } from '@osmosis/constants';
import {
  formattedGroupName,
  translateGroupName,
} from '../../../lib/library/format';
import L2Item from './L2Item';
import { useIntl } from 'react-intl';

/**
 * FormattedUrl.
 */
const L1Item = (props: {
  l1: LoggedOutProductLibraryContainsItem;
  groupName?: string;
  targetId?: string;
  showCta?: boolean;
}) => {
  const { l1, groupName = '', targetId, showCta = false } = props;
  const intl = useIntl();
  const imageLogo = groupName ? (
    <Image src={assets.logoIcon} alt="Icon" width={24} height={24} />
  ) : (
    <Icon icon={faFolderOpen} fontSize={24} />
  );
  // Translate the cleaned groupName
  const translatedGroupName = translateGroupName(groupName, intl);

  // Add the `/` back after translation
  const finalGroupName = `${translatedGroupName} /`;

  return (
    <Box key={l1.id} data-id={l1.id}>
      <Flex data-testid="subject-name" cn="items-center p-2 gap-8">
        {imageLogo}
        <H2
          cn="flex justify-start items-center flex-nowrap px-0 sm:px-2 gap-2"
          data-testid="subject-name-title"
        >
          {groupName ? (
            <span className={`${text2}`}>{finalGroupName}</span>
          ) : null}
          <span>{formattedGroupName(l1.displayName || l1.name)}</span>
        </H2>
      </Flex>

      {l1?.contains?.map(
        (l2: LoggedOutProductLibraryContainsItem, index: number) => (
          <L2Item
            key={'l2' + l2.id}
            l1={l1}
            l2={l2}
            {...(targetId && { targetId })}
            showCta={showCta && index === 0}
          />
        ),
      )}
    </Box>
  );
};

export default L1Item;
